/* eslint-disable no-restricted-imports */
import {
  Button as ChakraButton,
  ButtonProps as ChakraButtonProps,
  useColorModeValue,
} from '@chakra-ui/react';
import { forwardRef } from 'react';
import { buttonClickedEvent } from 'src/libs/amp';

type Variant = 'solid' | 'outline' | 'ghost' | 'link' | 'primary';

export type ButtonProps = Omit<ChakraButtonProps, 'colorScheme' | 'variant'> & {
  variant?: Variant;
  buttonName: string;
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, buttonName, onClick, variant, ...btnProps }, ref) => {
    const buttonColorScheme = useColorModeValue('button.light', 'button.dark');

    // Apply primary variant styles (common green button pattern)
    const primaryStyles =
      variant === 'primary'
        ? {
            bg: 'icon.green',
            color: 'white',
            borderRadius: 'md',
            fontWeight: 'semibold',
            _hover: { bg: 'green.500' },
            ...btnProps,
          }
        : btnProps;

    return (
      <ChakraButton
        ref={ref}
        alignSelf={'baseline'}
        onClick={(e) => {
          if (onClick) {
            buttonClickedEvent({
              buttonName,
            });
            onClick(e);
          }
        }}
        colorScheme={variant === 'primary' ? undefined : buttonColorScheme}
        variant={variant === 'primary' ? 'solid' : variant}
        {...primaryStyles}>
        {children}
      </ChakraButton>
    );
  },
);

Button.displayName = 'Button';
